import { FaUser, FaUsers, FaMountain } from 'react-icons/fa';
import images from './images';

const pricing = [
  {
    id: 1,
    image: images.plan1,
    icon: <FaUser />,
    title: 'Individual Explorer',
    price: 99.00,
    features: [
      'Unlimited Trail Access',
      'Exclusive Member Events',
      'Discounts on Camping Gear',
      'Monthly Outdoor Workshops',
      'Priority Booking for Group Hikes',
    ],
  },
  {
    id: 2,
    image: images.plan2,
    icon: <FaUsers />,
    title: 'Family Explorer',
    price: 199.00,
    features: [
      'Trail Access for 5 people',
      'Family Camping Nights',
      'Discounts on Outdoor Activities',
      'Monthly Nature Education',
      'Priority Booking for Family Camps',
    ],
  },
  {
    id: 3,
    image: images.plan3,
    icon: <FaMountain />,
    title: 'Patron Explorer',
    price: 499.00,
    features: [
      'VIP Trail Access',
      'Exclusive Expedition Events',
      'Private Guided Tours',
      'Monthly Outdoor Skills Workshops',
      'Personalized Camping Equipment',
    ],
  },
];

export default pricing;